<template>
    <li :class="{ 'is-active': isActive }">
        <div class="accordion-header text-sm" @click="isActive ? closeItem() : openItem()">
            <span class="h6 m-0">
                <img style="float:left;margin-top:6px;" :src="require('@/assets/images/'+title.status_name+'.png')"/>&nbsp;&nbsp;[<span style="color:blue;">{{title.status_name}}</span>]{{title.lineone_number}}
                <span v-if="title.lastTrack.eventDate !== ''" style="margin-left:5px;">{{title.shipment_number}}</span>
                <span v-if="title.lastTrack.eventDate !== ''" style="margin-left:10px;">{{title.Origin}} -> {{title.Destination}}</span>
                <span v-if="title.lastTrack.eventDate !== ''" style="margin-left:10px;">[{{title.lastTrack.eventDate}}][{{title.lastTrack.eventLocation}}]</span>
                <span style="margin-left:10px;">{{title.lastTrack.eventDescription}}</span>
                </span>
            <div class="accordion-icon"></div>
        </div>
        <div ref="content" class="accordion-content text-xs">
            <p>
                <slot />
            </p>
        </div>
    </li>
</template>

<script>
export default {
  name: 'CAccordionItem',
  props: {
    active: Boolean,
    title: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isActive: this.active || false
    }
  },
  methods: {
    openItem() {
      this.$refs.content.style.maxHeight =
        this.$refs.content.scrollHeight + 'px'
      this.isActive = true
    },
    closeItem() {
      this.$refs.content.style.maxHeight = null
      this.isActive = false
    }
  },
  mounted() {
    this.isActive && this.openItem()
  }
}
</script>
